var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('v-img',{attrs:{"max-height":"250px","height":"100%","width":"100%","contain":"true","src":"https://anniblob.blob.core.windows.net/images/Grafik_Startseite_Digitale_Hilfsmittelberatung.webp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }